// 歌单广场
import fetch from './fetch';

export const log = (ext) => {
    fetch(`/api/rep/video/song/down/record/interview/add?ext=${ext}`);
}